import React from 'react';
import {
  showAsRequired,
  isDateControl,
  isDescriptionHidden,
  isTimeControl,
  or,
  RankedTester,
  rankWith,
} from '@jsonforms/core';
import { TextInput, Text, Box } from '@mantine/core';
import merge from 'lodash/merge';
import { useDebouncedChange, useFocus } from '../utils';
import { ControlProps } from '../../types/controlProps';
import { withJsonFormsControlProps } from '../utils/withJsonFormsPropsMappers';
import { useVisibilityLevelContext } from '../../contexts/VisibilityLevelContext';

export const MantineNativeControl = (props: ControlProps) => {
  const [focused, onFocus, onBlur] = useFocus();
  const { isLevelEnabled } = useVisibilityLevelContext();

  const { id, errors, label, schema, description, enabled, visible, required, path, handleChange, data, config } =
    props;

  const propertyLevel = schema.level;
  const isValid = errors.length === 0;
  const appliedUiSchemaOptions = merge({}, config, props.uischema.options);
  const [inputValue, onChange] = useDebouncedChange(handleChange, '', data, path);
  const fieldType = appliedUiSchemaOptions.format ?? schema.format;
  const showDescription = !isDescriptionHidden(
    visible,
    description,
    focused,
    appliedUiSchemaOptions.showUnfocusedDescription
  );

  if (!visible || !isLevelEnabled(propertyLevel)) {
    return null;
  }

  return (
    <Box>
      <TextInput
        required={showAsRequired(!!required, appliedUiSchemaOptions.hideRequiredAsterisk)}
        id={id + '-input'}
        label={label}
        type={fieldType}
        error={!isValid}
        disabled={!enabled}
        w={!appliedUiSchemaOptions.trim ? '100%' : undefined}
        onFocus={onFocus}
        onBlur={onBlur}
        value={inputValue}
        onChange={onChange}
      />
      {!isValid ? <Text c='red'>{errors}</Text> : showDescription ? <Text>{description}</Text> : null}
    </Box>
  );
};

export const mantineNativeControlTester: RankedTester = rankWith(2, or(isDateControl, isTimeControl));

export default withJsonFormsControlProps(MantineNativeControl);
